import { render, staticRenderFns } from "./Ofertas.vue?vue&type=template&id=103f3c6f"
import script from "./Ofertas.vue?vue&type=script&lang=js"
export * from "./Ofertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('103f3c6f')) {
      api.createRecord('103f3c6f', component.options)
    } else {
      api.reload('103f3c6f', component.options)
    }
    module.hot.accept("./Ofertas.vue?vue&type=template&id=103f3c6f", function () {
      api.rerender('103f3c6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Ofertas/UY/Ofertas.vue"
export default component.exports